import * as React from 'react';
import { twMerge } from '@belong/common/twMerge';
import { getSizeClassName, transition, defaultStylesMap, hoverMap } from '../Button/Button.js';
import { LinkBase } from '../LinkBase/LinkBase.js';

const Link = /*#__PURE__*/React.forwardRef(function Link({
  variant = 'text',
  buttonType = 'primary',
  size = 'auto',
  disabled = false,
  className,
  uppercase,
  theme = 'light',
  ...rest
}, ref) {
  let _uppercase = uppercase;
  if (typeof uppercase === 'undefined' && variant === 'text') {
    _uppercase = true;
  }
  return /*#__PURE__*/React.createElement(LinkBase, {
    className: twMerge('font-semibold rounded flex items-center justify-center', _uppercase && 'uppercase', getSizeClassName(size), transition, defaultStylesMap[variant]?.[buttonType], theme === 'dark' && 'text-white', hoverMap[variant]?.[buttonType], disabled && disabledMap[variant], className),
    ref: ref,
    ...rest
  });
});
const disabledMap = {
  solid: 'bg-gray shadow-none pointer-events-none',
  outline: 'bg-gray shadow-none border-gray pointer-events-none',
  text: 'text-gray pointer-events-none'
};

export { Link };
